import React, {useCallback, useMemo} from 'react';
import {isArena, isSwarm, sortChampData} from "../../../function";
import useArenaFunc from "../useArenaFunc";

const UseMatchBackground = ({match, targetPuuId,target}) => {
    const {getArenaTeam} = useArenaFunc({match})
    const Aisort = [{
        value: 'is_win', sortType: false,
    }, {
        value: 'ai_score', sortType: false,
    }];
    const myMatch = useMemo(() => {
        try {

            const list = match?.participants_list
            if (Array.isArray(list)) {
                let item = list.find((data) => data?.puu_id === targetPuuId);
                if (typeof list === 'object') {
                    if (isArena(match?.match_basic_dict.queue_id)) {
                        const arena_team = getArenaTeam(item);
                        item = {
                            ...item,
                            arena_team,
                        }
                    }
                    return item
                }
            }
            return {}
        } catch (e) {
            return {}
        }
    }, [match, targetPuuId]);


    const AiMemo = useMemo(() => match && sortChampData(match.participants_list, Aisort), [match]);

    const HardCarryGap = useMemo(() => {
        if (match) {
            const reducedList = match.participants_list.reduce((sum, data, index) => {

                if (data.is_win) {
                    sum.list.push(data);
                    if (sum.list.length > 0) {
                        sum.aiScoreAvg = Math.trunc(sum.list.reduce((sum, cur) => sum + cur.ai_score, 0) / sum.list.length)
                    } else {
                        sum.aiScoreAvg = data.ai_score;
                    }
                }
                return sum;
            }, {list: [], aiScoreAvg: 0,});


            const aiScoreList = reducedList.list.reduce((sum, cur) => {
                sum.push(cur.ai_score);
                return sum;
            }, []);
            const getHighestAiScore = Math.max(...aiScoreList);
            const findIndex = aiScoreList.findIndex((data) => data === getHighestAiScore);

            const getAvg = aiScoreList.reduce((sum, cur, index) => {
                if (index === findIndex) {
                    return sum;
                }

                sum.list.push(cur);
                if (sum.list.length > 0) {
                    sum.aiScoreAvg = Math.trunc(sum.list.reduce((sum, cur) => sum + cur, 0) / sum.list.length)
                } else {
                    sum.aiScoreAvg = cur;
                }

                return sum;
            }, {
                list: [], aiScoreAvg: 0,
            })


            return {
                ...reducedList.list[findIndex], gap: getHighestAiScore - getAvg.aiScoreAvg,
            }
        }
        return {
            riot_id_name: "", gap: 0,
        }
    }, [match,targetPuuId])
    const isHardCarry = useCallback(() => {
        if (isArena(match?.match_basic_dict.queue_id)) {
            return false
        }


        if (isSwarm(match?.match_basic_dict.queue_id)) {
            return false;
        }


        if (AiMemo[0]?.puu_id) {
            if (AiMemo[0]?.puu_id === HardCarryGap?.puu_id && HardCarryGap?.puu_id === myMatch?.puu_id) {
                return AiMemo[0].ai_score >= 75 && AiMemo[0].is_win && HardCarryGap.gap >= 25;
            }
        }

        return false;
    }, [AiMemo, HardCarryGap, myMatch,targetPuuId]);


    const getBackgroundString = () => {
        try {
            if (isHardCarry()) {
                return 'hardcarry'
            }
            if (target.is_win) {
                return 'win'
            }
            return 'lose'
        } catch (e) {
            console.log(e)
            return 'lose'
        }
    }

    return {
        isHardCarry,
        myMatch,
        getBackgroundString
    }
};

export default UseMatchBackground;